/**
 * Archived Messages Tab
 * Mirrors DeletedChildrenTab — red/pink banner, Clear All, list of archived message cards.
 */
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Trash2 } from "lucide-react";
import { ArchivedMessageCard } from "./ArchivedMessageCard";

export const ArchivedMessagesTab = ({ messages, onRestore, onDelete, onClearAll }) => {
  if (messages.length === 0) {
    return (
      <Card className="bg-red-50/80 backdrop-blur-sm border-2 border-red-200">
        <CardContent className="p-8 text-center">
          <p className="text-red-600 text-sm">No archived messages.</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {/* Warning Banner with Clear All */}
      <Card className="bg-red-100 border-red-300">
        <CardContent className="p-4">
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-red-600 mt-0.5 shrink-0" />
              <div>
                <p className="font-semibold text-red-800">Archived Messages ({messages.length})</p>
                <p className="text-sm text-red-700 mt-1">
                  These messages have been archived. You can re-establish them to move them back to the inbox, or permanently delete them. Permanently deleted messages cannot be recovered.
                </p>
              </div>
            </div>
            <Button
              onClick={onClearAll}
              variant="destructive"
              size="sm"
              className="bg-red-600 hover:bg-red-700 text-white shrink-0"
              data-testid="clear-all-archived-messages-btn"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Clear All
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Archived Message List */}
      <div className="grid gap-4">
        {messages.map((msg) => (
          <ArchivedMessageCard
            key={msg.id}
            msg={msg}
            onRestore={onRestore}
            onDelete={onDelete}
          />
        ))}
      </div>
    </div>
  );
};

export default ArchivedMessagesTab;
